import React, { useEffect, createContext, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuth } from '../../context/AuthContext';
import $ from "jquery";
import { BrowserView, MobileView } from 'react-device-detect';

import { useTranslation } from 'react-i18next';
import Navbar from '../Dashboard/DashboardComponents/Navbar';
import MobileNavbar from '../Dashboard/DashboardComponents/MobileNavbar';
import MobileNavbarManager from '../Dashboard/DashboardComponents/MobileNavbarManager';
import MobileNavbarAdmin from '../Dashboard/DashboardComponents/MobileNavbarAdmin';
import BrowserSidebarAdmin from '../Dashboard/DashboardComponents/BrowserSidebarAdmin';
import SidebarHeader from '../Dashboard/DashboardComponents/SidebarHeader';
import TeacherSidebarDetail from '../Dashboard/DashboardComponents/TeacherSidebarDetail'
import ManagerSidebarDetail from '../Dashboard/DashboardComponents/ManagerSidebarDetail'
import MobileNavbarStudent from '../Dashboard/DashboardComponents/MobileNavbarStudent'
import MobileNavbarTeacher from "./DashboardComponents/MobileNavbarTeacher";

export const LayoutContext = createContext();

function DashboardLayout() {
    const [contentStyle, setContentStyle] = useState({});
    const { user, setUser, refreshUser } = useAuth();


    const { t } = useTranslation();
    //i18n.changeLanguage("tr")
    function onClick(event) {
        const body = document.body;

        if (event.currentTarget.id === "arrow" || event.currentTarget.id === "arroww") {
            const sidebar = document.getElementById("sidebar");
            sidebar.classList.toggle("active");

            body.classList.toggle("sidebar-collapsed"); // 🔥 EKLENDİ
            $(".forsidebar").toggle();
        }
    }

    useEffect(() => {
        refreshUser(); // ?? SADECE B?R KERE
    }, []);

    useEffect(() => {

        console.log("DashboardLayout - User State Güncellendi:", user)
        if (!user || !user.tokenData) return;
        var date = Date.parse(user.tokenData);
        if (date < Date.now()) {
            setUser(false);
        }
    }, [user, setUser]);
    if (!user) {
        return <Navigate to="/auth/login" replace />;
    }
    if (user['role'] === "SysAdmin") {
        return (
            <div >
                <BrowserView>
                    <Navbar />
                    <div className="wrapper">
                        <nav id="sidebar" style={{ backgroundColor: "SteelBlue" }}>
                            <SidebarHeader onClick={onClick} />
                            <BrowserSidebarAdmin />
                        </nav>
                        <div id="content">
                            <div className="container">
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </BrowserView>


                <MobileView>
                    <MobileNavbarAdmin />
                    <div>
                        <Outlet />
                    </div>
                </MobileView>
            </div>

        );
    }
    else if (user['role'] === "Yönetici") {
        return (
            <div>
                <BrowserView>
                    <Navbar />
                    <div className="wrapper">
                        <nav id="sidebar" style={{ backgroundColor: "SteelBlue" }}>
                            <SidebarHeader onClick={onClick} />
                            <ManagerSidebarDetail />
                        </nav>

                        <div id="content">
                            <div className="container">
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </BrowserView >
                <MobileView>
                    <MobileNavbarManager />
                    <div>
                        <Outlet />
                    </div>
                </MobileView>
            </div >

        );
    }
    else if (user['role'] === "Öğrenci") {
        if (user.userDetail.sectionId === 1) {
            return <Navigate to="/profile" replace />;
        }
        else {
            return (
                <LayoutContext.Provider value={{ contentStyle, setContentStyle }}>
                    <BrowserView>
                        <Navbar />
                        <div className="wrapper">
                            <nav id="sidebar" style={{ backgroundColor: "SteelBlue" }}>
                                <SidebarHeader onClick={onClick} />
                                <ul className="list-unstyled components ">
                                    <li className="active" id="general">
                                        <li>
                                            <a href="/user/course" id="generals" style={{ color: "Gainsboro" }}>
                                                <FontAwesomeIcon icon="fas fa-university" />
                                                <span style={{ marginLeft: "4%" }}>
                                                    {t('course')}
                                                </span>

                                            </a>
                                        </li>
                                    </li>
                                </ul>

                                <ul className="list-unstyled components ">
                                    <li className="active" id="general">
                                        <li>
                                            <a href="/usergeneral" id="generals" style={{ color: "Gainsboro" }}>
                                                <FontAwesomeIcon icon="fas fa-university" />
                                                <span style={{ marginLeft: "4%" }}>
                                                    {t('generalreport')}
                                                </span>

                                            </a>
                                        </li>
                                    </li>
                                    <br />
                                    <li className="active" id="skills">
                                        <li>
                                            <a href="/userskill" id="skillss" style={{ color: "Gainsboro" }}>
                                                <FontAwesomeIcon icon="fas fa-chart-bar" />
                                                <span style={{ marginLeft: "4%" }}>
                                                    {t('skills')}
                                                </span>
                                            </a>
                                        </li>
                                    </li>
                                </ul>
                            </nav>

                            <div id="content" style={contentStyle}>
                                <div className="container" >
                                    <Outlet />
                                </div>
                            </div>
                        </div>
                    </BrowserView>
                    <MobileView>
                        <MobileNavbarStudent />
                        <Outlet />
                    </MobileView>
                </LayoutContext.Provider>

            );
        }

    }
    else if (user['role'] === "Öğretmen") {
        return (
            <div>
                <BrowserView>
                    <Navbar />
                    <div className="wrapper">
                        <nav id="sidebar" style={{ backgroundColor: "SteelBlue" }}>
                            <SidebarHeader onClick={onClick} />
                            <TeacherSidebarDetail />

                        </nav>

                        <div id="content">
                            <div className="container">
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </BrowserView>
                <MobileView>
                    <MobileNavbarTeacher />
                    <div>
                        <Outlet />
                    </div>
                </MobileView>
            </div>
        );
    }

}


export default DashboardLayout;
